<template>
  <div class="report-imgs">
    <div class="report-imgs__title">
      <!-- <div> -->
      <!-- 【{{ title }} -->
      <div class="title-conctent">
        <tag type="success">当前</tag>
        <div class="value">
          {{ current.date }} <span class="value-desc">【合计】</span>
          {{ current.total }}
        </div>

        <tag type="danger">高峰</tag>
        <div class="value">
          {{ statistic.max.date }} <span class="value-desc">【合计】</span>
          {{ statistic.max.total }}
        </div>

        <tag type="warn">首次</tag>
        <div class="value">
          {{ statistic.first.date }} <span class="value-desc">【合计】</span>
          {{ statistic.first.total }}
        </div>
      </div>

      <!-- </div> -->
    </div>

    <div class="report-imgs__content" v-loading="loading">
      <div class="report-img-card" v-for="im in images" :key="im.id">
        <el-image
          lazy
          fit="cover"
          :src="im.tempPath"
          :style="{ height: `auto`, width: '100%' }"
          @click="showDetail(im.id)"
        ></el-image>

        <div class="report-img-label">数量: {{ im.qty }}</div>
        <div class="report-img-label_lb">{{ im.createdAt | formatDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import showScannerDetail from '../images/model'
import Tag from '@/components/Tag'

export default {
  components: { Tag },
  props: {
    title: String,
    imgs: Array,
    loading: Boolean,
    cates: Array,
    checked: Array,
    statistic: Object,
    current: Object,
    groupType: String,
    devs: Array
  },
  computed: {
    categories() {
      return this.cates
        .filter((c, idx) => this.checked.includes(idx))
        .map(i => i.id)
    },
    devIds() {
      return this.devs.map(d => d.id)
    },
    images() {
      return this.imgs
        .map(o => {
          let qty = o.insects.reduce((total, cur) => {
            return this.categories.includes(cur.categoryId)
              ? total + cur.qty
              : total
          }, 0)
          return { ...o, qty }
        })
        .filter(o => o.qty > 0 && this.devIds.includes(o.deviceId))
    }
  },
  methods: {
    showDetail(id) {
      showScannerDetail({ id, query: { limit: 1 } })
    }
  }
}
</script>

<style lang="scss" scoped>
.report-imgs {
}
.report-imgs__content {
  display: flex;
  flex-wrap: wrap;
  min-height: 200px;
  grid-gap: 12px;
  padding: 12px;
}
.report-imgs__title {
  font-size: 16px;
  padding: 0 20px;
  .title-conctent {
    padding: 12px 0;
    border-bottom: 1px dashed #c1c1c1;
    .value {
      display: inline-block;
      padding-left: 8px;
      padding-right: 20px;
    }
    .value-desc {
      color: #909399;
    }
  }
}
.report-img-card {
  // padding: 8px;
  cursor: pointer;
  width: 12%;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d1d1d1;
}
.report-img-label {
  color: #fff;
  font-size: 1rem;
  position: absolute;
  left: 12px;
  top: 12px;
  text-shadow: 0 0 4px #000;
}
.report-img-label_lb {
  width: 80%;
  padding: 8px 12px;
  word-break: break-word; /* 强制任意字符换行 */
  overflow-wrap: break-word; /* 优先保留单词完整性 */
}
</style>
